import { useNavigate, useParams } from "react-router-dom"
import { useReadPropertySpyByIdQuery, useSetChangesViewedMutation } from "services/propertySpy"
import { Box } from "@mui/material"
import { PropertySpyItemDetailHeader } from './presentationals/PropertySpyItemDetailHeader'
import { PropertySpyItemDetailChangeListViewContainer } from './containers/PropertySpyItemDetailChangeListViewContainer'
import { PropertySpyItemDetailChangePhotoListContainer } from './containers/PropertySpyItemDetailChangePhotoListContainer'
import { PropertySpyItemDetailChangeListCalendarContainer } from './containers/PropertySpyItemDetailChangeListCalendarContainer'
import { useEffect, useState } from "react"
import { DateTime } from "luxon"
import { Photo } from "shared/ui/strspykit/PhotoListCarousel/PhotoListCarousel"
import { Excluded_Changeable_Fields_For_Property } from "shared/constants/excludedChangeableFieldsForProperty"
import { ApplicationMainToolbarContent } from "shared/widgets/ApplicationMainToolbarContent"
import { useDynamicMainToolbar } from "shared/hooks/useMainToolbar"
import { ImageSlider2 } from 'shared/ui/strspykit/ImageSlider2'
import styles from './PropertySpyItemDetail.module.css'
import classNames from "classnames"
import { useReadChangeLogsQuery } from "entities/propertySpy/api/propertySpyApi"
import { ReadChangeLogsParamsModel } from "@/entities/propertySpy/api/types"

interface PropertySpyItemDetailProps {

}

export const PropertySpyItemDetail = (props: PropertySpyItemDetailProps): JSX.Element => {
    const { id: propertySpyIdString } = useParams()
    const propertySpyId = propertySpyIdString ? parseInt(propertySpyIdString) : NaN
    const [selectedDay, setSelectedDay] = useState<DateTime | undefined>(undefined)
    const [changesWithoutImagesPerDay, setChangesWithoutImagesPerDay] = useState<any | undefined>(undefined)
    const [data, setData] = useState<Map<any,any> | undefined>(undefined)
    const [slides, setSlides] = useState<any[]>([])
    const [setChangesViewedMutation] = useSetChangesViewedMutation()
    const navigate = useNavigate()

    const handleBack = () => {
        navigate(-1)
    }

    const mainToolbarContent = (
        <ApplicationMainToolbarContent
            title={`Changes`}
            back={{
                callback:handleBack
            }}
        />
    )

    useDynamicMainToolbar(mainToolbarContent, [])

    //{useReadChangeLogsQueryData
    const useReadChangeLogsQueryParams: ReadChangeLogsParamsModel = {
        propertySpyId: propertySpyId,
        pagination: {
            page: 0,
            pageSize: 100
        }
    }

    const useReadChangeLogsQueryOptions = {
        skip: isNaN(propertySpyId)
    }

    const {
        data: useReadChangeLogsQueryData,
        isLoading: useReadChangeLogsQueryIsLoading,
        isFetching: useReadChangeLogsQueryIsFetching,
        error: useReadChangeLogsQueryError
    } = useReadChangeLogsQuery(useReadChangeLogsQueryParams, useReadChangeLogsQueryOptions)
    //useReadChangeLogsQueryData}

    //{useReadPropertySpyByIdQuery
    const readPropertySpyByIdQueryParams = {
        propertySpyId: propertySpyId
    }

    const readPropertySpyByIdQueryOptions = {
        skip: isNaN(propertySpyId)
    }

    const {
        data: useReadPropertySpyByIdQueryData,
        isLoading: readPropertySpyByIdQueryIsLoading,
        isFetching: readPropertySpyByIdQueryIsFetching,
        error: readPropertySpyByIdQueryError
    } = useReadPropertySpyByIdQuery(readPropertySpyByIdQueryParams, readPropertySpyByIdQueryOptions);
    //useReadPropertySpyByIdQuery}

    let name = ``
    if (useReadPropertySpyByIdQueryData !== undefined) {
        name = useReadPropertySpyByIdQueryData.name
    }

    useEffect(() => {
        if (useReadChangeLogsQueryData === undefined) {
            setData(undefined)
            return
        }

        setChangesViewedMutation({
            hostServiceId: propertySpyId
        })

        const groupingData = new Map()

        for (let i = 0; i < useReadChangeLogsQueryData.list.length; i++) {
            const item: any = useReadChangeLogsQueryData.list[i]

            //if (excludedChangeableFieldsForProperty.con)
            if (Excluded_Changeable_Fields_For_Property.includes(item.propName) === true) {
                continue
            }

            const eventDate = DateTime.fromISO(item.timestampUtc)
            const indexString: string | null = eventDate.toSQLDate()

            if (!groupingData.has(indexString)) {
                groupingData.set(indexString, [])
            }

            const gdItem = groupingData.get(indexString)
            gdItem.push(item)
        }

        setData(groupingData)

    }, [
        useReadChangeLogsQueryData
    ])

    useEffect(() => {
        if (useReadPropertySpyByIdQueryData === undefined) {
            setSlides([])
            return
        }

        const slidesHandled = useReadPropertySpyByIdQueryData.strHostservice.strHostservicePictures
            .map((strHostservicePicture: any) => {
                return ({
                    src: strHostservicePicture.url,
                    title: strHostservicePicture.description
            })
        })

        setSlides(slidesHandled)
    }, [
        useReadPropertySpyByIdQueryData
    ])

    const handleChangesPer = (day: DateTime) => {
        if (data === undefined) {
            return
        }

        const indexString: string | null = day.toSQLDate()

        if (data.has(indexString)) {
            //const dataItem = data.get(indexString)
            setChangesWithoutImagesPerDay(Array.from(data, ([name, value]) => (value)).flat())
            return
        }

        setChangesWithoutImagesPerDay(undefined)
    }

    if (selectedDay === undefined && data !== undefined && data.size > 0) {
        const first = data.entries().next().value
        if (first !== undefined){
        const day = DateTime.fromISO(first[0])
            setSelectedDay(day)
            handleChangesPer(day)
        }
    }

    const renderData = () => {
        if (data?.size === 0) {
            return (
                <Box sx={{ fontSize: '24px', fontWeight: '600' }}>
                    No changes detected
                </Box>
            )
        }

        return (
            <PropertySpyItemDetailChangeListViewContainer
                data={changesWithoutImagesPerDay}
            />
        )
    }

    const render = () => {
        if (readPropertySpyByIdQueryIsLoading === true){
            return (
                <div>
                    Loading
                </div>
            )
        }

        return (
            <>
                <div className={styles.PropertySpyItemDetail__PropertySpyItemDetailHeaderContainer}>
                    <PropertySpyItemDetailHeader
                        name={name}
                    /> 
                </div>
                <div className={styles.PropertySpyItemDetail__ImageSliderContainer}>
                    <div>
                        <ImageSlider2 
                        images={slides}
                    />
                    </div>  
                </div>
                <div className={styles.PropertySpyItemDetail__ChangesContainer}>
                    {
                        renderData()
                    }
                </div>
            </>
        )
    }

    const PropertySpyItemDetailClasses = classNames(styles.PropertySpyItemDetail, {
        [styles[`PropertySpyItemDetail--Loading`]]: readPropertySpyByIdQueryIsLoading,
    })

    return (
        <div
            className={PropertySpyItemDetailClasses}
        >
            { 
                render()
            }
        </div>   
    )
}